<template>
  <ContentWrapper>
    <div>
      <div class="instrument-calender-nobody d-flex justify-content-center mb-3">
        <el-date-picker
          v-model="date"
          type="month"
          placeholder="Pick a month"
          @change="changedMonth(date)"
          >
        </el-date-picker>
        <!-- <vc-calendar
            v-model="today"
            @change="changedMonth(today)"
            format="MMMM-yyyy" value-format="MM-yyyy" type="month"
        /> -->
      </div>
      <table class="table table-striped table-hover" style="text-align:center;">
        <tr v-for="(item, index) in monthList" :key="index">
          <td style="vertical-align: middle; border: 1px solid #e9edef;"><input type="radio" class="form-control" name="anniversary" style="width:20px;" @click="selectedItem(item)"></td>
          <td style="vertical-align: middle; border: 1px solid #e9edef;" >{{item.day}}</td>
          <td style="vertical-align: middle; border: 1px solid #e9edef;">{{item.lunarYn == 'Y' ? "음력" : "양력"}}</td>
          <td style="vertical-align: middle; border: 1px solid #e9edef;">{{item.title}}</td>
        </tr>
      </table>
      <div class="footer">
        <div class="float-right">
          <b-button @click="save()" :disabled="!anniversary" class="btn btn-b mr-2" variant="info">선택</b-button>
          <b-button @click="close()" class="btn btn-b mr-2" variant="outline-info">닫기</b-button>
        </div>
      </div>
    </div>
  </ContentWrapper>
</template>

<script>
import Vue from 'vue';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/ko'
import 'element-ui/lib/theme-chalk/index.css';
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api'
import {setMomentdayList, setMomentdayListOrderNum, getMomentdayList} from "@/api/exhibit/moment/MomentdayApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject,purpTypeCd, fileTypeCd, fileDivCdMap, aws_cdn_path} from "@/utils/Constants";
import VCalendar from 'v-calendar';
import Axios from 'axios';

Vue.use(VCalendar, {
    componentPrefix: 'vc'
});
Vue.use(ElementUI, { locale });

export default {
  components: {Pagenation,VCalendar},
  props:{
    monthdata:'',
    yeardata:'',
  },
  setup(props,context) {
    const month = props.monthdata;
    const year = props.yeardata;
    const date = ref(new Date(year, month-1));

    const monthList = ref();
    const anniversary = ref(null); //선택된 날짜 객체 

    const loadData = async() => {
      await setMonthList(props.yeardata,props.monthdata);
    }

    const setMonthList = async (year,month) => {
      monthList.value = null;
      let result = await getMomentdayList({
        year : year,
        month : month,
      });
      if(result != null){
        monthList.value = result.data;
      }
    }

    const changedMonth = async(date) => {
      await setMonthList(date.getFullYear(), date.getMonth()+1);
    }

    const selectedItem = (item) => {
      anniversary.value = item;
    } 

    const close = () =>{
      context.emit('closePopup', '5' );
    }

    const save = () =>{
      const item = anniversary.value;
      item.lunar = {};
      item.lunar.date = item.lunarDisplayDate;
      const lunarArray = item.lunarDisplayDate.split('-');
      item.lunar.year = parseInt(lunarArray[0]);
      item.lunar.month = parseInt(lunarArray[1]);
      item.lunar.day = parseInt(lunarArray[2]);
      context.emit('set-Anniversary', item);
    }

    onMounted(loadData);

    return {
      date,
      monthList,
      anniversary,
      changedMonth,
      selectedItem,
      close,
      save,
    }
  },
}

</script>
